export const CONTEXT_MENU_TESTID = 'table-context-menu';

export const CONTEXT_MENU_TESTIDS = {
  hideColumn: 'context-menu-hide-column',
  lockLeft: 'context-menu-lock-left',
  lockRight: 'context-menu-lock-right',
  unpin: 'context-menu-unpin',
  sortBy: 'context-menu-sort-by',
  groupBy: 'context-menu-group-by',
  // Kept as the legacy id so existing Playwright specs keep passing.
  filterByElement: 'filter-by-value-menu-item',
  resetWidths: 'context-menu-reset-widths',
  collapseAll: 'context-menu-collapse-all',
  expandAll: 'context-menu-expand-all',
  zoomIn: 'context-menu-zoom-in',
  zoomOut: 'context-menu-zoom-out',
  resetZoom: 'context-menu-reset-zoom',
  sortNone: 'context-menu-sort-none',
  removeFromSort: 'context-menu-remove-from-sort',
} as const;

export const sortOptionTestId = (field: string): string => `context-menu-sort-${field}`;
export const sortRemoveTestId = (field: string): string => `context-menu-sort-remove-${field}`;
export const sortPriorityTestId = (field: string): string => `context-menu-sort-priority-${field}`;
export const groupOptionTestId = (field: string): string => `context-menu-group-${field}`;
